import { combineReducers } from 'redux';

import settingsReducer from './settings.reducer.js';
import themesReducer from './themes.reducers.js';
import userReducer from './user.reducers.js';
import pageReducer from './page.reducers.js'
import menuReducer from './menu.reducers'

export default combineReducers({
    settings: settingsReducer,
    theme: themesReducer,
    user: userReducer,
    page: pageReducer,
    menu: menuReducer
});
